module.exports = __webpack_public_path__ + "static/p13_becerroOrejaL-4fcb4b0b3026ccc80d4c761d0a8a1bd1.png";